import { Space, Row, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';
import { TaxPeriodsTableProps, UlTaxInfo } from '../find-taxpayer-service.type';
import { localize } from '/react4xp/mixins/helpers';

export function TaxPeriodsTable({ ulTaxInfo, translations }: TaxPeriodsTableProps) {
    const titleColumn = {
        key: 'taxType',
        title: localize('find-taxpayer-service-tax-type', translations),
        dataIndex: 'taxType',
    };

    const yearColumns = ulTaxInfo
        .sort((a, b) => a.year - b.year)
        .map(({ year }, index, array) => {
            const translationKey =
                index === array.length - 1
                    ? 'find-taxpayer-service-reporting-period'
                    : 'find-taxpayer-service-period';

            const title = localize(translationKey, translations).replace(
                '__YEAR__',
                year.toString()
            );

            return { key: year.toString(), dataIndex: year.toString(), title };
        });

    const columns: ColumnsType = [titleColumn, ...yearColumns];

    const rowsToLocaleMap: Record<keyof Omit<UlTaxInfo, 'year'>, string> = {
        taxIncome: localize('find-taxpayer-service-tax-revenues', translations),
        vatReturn: localize('find-taxpayer-service-refund-amount', translations),
    };

    const dataSource = Object.keys(rowsToLocaleMap).map((row) => {
        const taxByYearData = ulTaxInfo.reduce((acc, item) => {
            acc[item.year] = item[row];
            return acc;
        }, {});

        return {
            taxType: rowsToLocaleMap[row],
            ...taxByYearData,
        };
    });

    return (
        <Space
            direction="vertical"
            size={16}
        >
            <Row className="description">
                {localize('find-taxpayer-service-payment-information', translations)}
            </Row>
            <Table
                className="table-default"
                bordered
                columns={columns}
                dataSource={dataSource}
                pagination={false}
            />
            <Row className="description">
                {localize('find-taxpayer-service-information-generated', translations)}
            </Row>
        </Space>
    );
}
